<template>
  <Layout>
    <Content :style="{'padding': '10px'}">
      <Breadcrumb :style="{margin: '5px 0'}">
        <BreadcrumbItem>通用管理 > <b>版本列表</b></BreadcrumbItem>
      </Breadcrumb>
      <Card>
        <Card :style="{'padding':'0px 5px','margin-bottom':'5px'}">
          <span class="search_span_width">
                <span class="search_span_width_part1">版本号：</span>
              <Input v-model="search.app_version" placeholder="请输入版本号" clearable :style="{'width':'110px'}"></Input>
            </span>
          <span class="search_span_width">
          <span class="search_span_width_part1">&nbsp;&nbsp;语言：</span>
          <Select v-model="search.lang" clearable style="width:150px">
            <Option value="zh" >中文</Option>
            <Option value="en" >英文</Option>
          </Select>
	      </span>
          <span class="search_span_width">
          <span class="search_span_width_part1">&nbsp;&nbsp;渠道：</span>
          <Select v-model="search.channel" clearable style="width:150px">
            <Option v-for="(item,index) in channel_list" :value="item.id" :key="index">{{ item.name }}</Option>
          </Select>
	      </span>
          <span class="search_span_width">
          <span class="search_span_width_part1">&nbsp;&nbsp;状态：</span>
          <Select v-model="search.status" clearable style="width:150px">
            <Option value="1" >未上线</Option>
            <Option value="2" >已上线</Option>
          </Select>
          </span>
          <Button type='primary' icon="ios-search" :style="{'margin-left':'20px'}" @click="getAppList(1)">搜索</Button>
        </Card>
       <p :style="{'margin':'5px 10px 10px 20px','clear':'both','overflow':'hidden'}">
			<span :style="{'text-align':'center','float':'left'}">
				<Button type='primary' :style="{'margin-left':'5px'}" @click="addModal()">添加版本</Button>
			</span>
        </p>
        <Card id="tableContent" >
          <Table :columns="tableColumns" :data="app_list"></Table>
          <Page :total="total" :current="page" :page-size="15" :show-elevator="true" @on-change="getAppList"/>
        </Card>
      </Card>
    </Content>
   <Modal v-model="showmodal" :footer-hide=true title="版本">
        <Form ref="app" :model="app" :label-width="80" >
			<FormItem label="渠道" prop="channel">
				 <Select v-model="app.channel" style="width:260px">
				 	<Option v-for="item in channel_list" :value="item.id" :key="item.id">{{ item.name }}</Option>
				 </Select>
			</FormItem>
   			<FormItem label="版本号" prop="app_version">
   				 <Input v-model="app.app_version"  />
   			</FormItem>
   			<FormItem label="介绍" prop="content">
   				 <Input v-model="app.content" type="textarea" :rows="4" />
   			</FormItem>
          <FormItem label="语言" prop="lang">
            <Select v-model="app.lang" clearable style="width:150px">
              <Option value="zh" >中文</Option>
              <Option value="en" >英文</Option>
            </Select>
          </FormItem>
   			<FormItem label="应用" prop="download_url">
				<Upload
					:before-upload="handleUpload"
					action="//jsonplaceholder.typicode.com/posts/">
					<Button icon="ios-cloud-upload-outline">请选择新版本文件</Button>
				</Upload>
				<Progress :percent="upLoadProgress" v-show="upLoadProgress_show" />
				<div v-if="file !== null">Upload file: {{ file.name }} <Button type="text" @click="doUpload" :loading="loadingStatus">{{ loadingStatus ? '上传中...' : '点击上传' }}</Button></div>
   			</FormItem>  
            <FormItem>
                <Button type="primary" @click="updateApp()">提交</Button>
            </FormItem>
        </Form>
    </Modal>
  </Layout>
</template>
<script>
const OSS = require('ali-oss');
export default {
  data(){
    return {
		showmodal:false,
		file:null,
		loadingStatus:false,
		upLoadProgress:0,
		upLoadProgress_show:false,
		app_list:[],
      total:0,
      search:{
        app_version:'',
        lang:'',
        channel:'',
        status:0,
      },
		channel_list:[],
		app:{
			id:0,
			app_version:'',
			channel:'fengping',
			is_force:'1',
			download_url:'',
			content:'',
      lang:''
		},
		tableColumns:[
		{ title: '版本号', key: 'app_version', align: 'center' },
		{ title: '渠道', key: 'channel_name', align: 'center' },
		{ title: '是否强制', key: 'is_force', align: 'center',
		 render:(h,params) =>{
			 var sub_type = '否';
		    if (params.row.is_force == 1) {
				sub_type = '是';
			}else if (params.row.is_force == 0) {
				sub_type = '否';
			}
			return h('span',{},sub_type);
		 }},
      { title: '语言', key: 'lang', align: 'center',
        render:(h,params) =>{
          var sub_type = '中文';
          if (params.row.lang == 'zh') {
            sub_type = '中文';
          }else if (params.row.lang == 'en') {
            sub_type = '英文';
          }
          return h('span',{},sub_type);
        }},
		 { title: '下载', key: 'download_url', align: 'center',
		 render:(h,params) =>{
		    return h('a',{
		 	 attrs : {
		 		href : params.row.download_url
		 	 }
		    },'下载')
		 }},
		{ title: '更新内容', key: 'content', align: 'center' },
		{ title: '状态', key: 'ip_type', align: 'center',
			render: (h, params) => {
				var txt = '';
				if (params.row.status =='0') {
					txt = '未上线';
				} else {
					txt = '已上线';
				}
				
				return h("div",{},txt);
			}
		},
		{ title: '操作', key: 'action', align: 'center',
		  render: (h, params) => {
			let btns=[]
			btns.push(
				h('Button', {
				  props: { type: 'warning', size: 'small' },
				  style: { marginRight: '5px', marginBottom: '5px'},
				  on: {
					click: () => {      
						this.app.id = params.row.id;
						this.app.content = params.row.content;
						this.app.app_version = params.row.app_version;
						this.app.download_url = params.row.download_url;
						this.app.is_force = params.row.is_force;
						this.app.channel = params.row.channel;
            this.app.lang = params.row.lang;
						this.showmodal = true;
					}
				  }
				}, '编辑'),
			);
			//上架
			btns.push(
				h('Button', {
				  props: { type: 'error', size: 'small' },
				  style: { marginRight: '5px', marginBottom: '5px'},
				  on: {
					click: () => {    
						
						this.shelfs(params.row.id,params.row.status=='0' ? 1: 0)
					}
				  }
				}, params.row.status == '0' ?'上架' :'下架'),
			);
			
			return h("div",btns);
		  }
		}
		]
	}
  },
  mounted:function(){
    this.getAppList();
	this.getSetting();
  },
  computed:{

  },
  methods:{
	addModal(){
		this.file = null;
		this.upLoadProgress_show = false;
		this.upLoadProgress = 0;
		this.app.id = 0;
		this.app.is_force = 0;
		this.app.app_version = '';
		this.app.content = '';
		this.app.download_url = '';
		this.app.channel = 'fengping';
		this.showmodal = true;
	},
	handleUpload (file) {
	  this.file = file;
	  return false;
	},
	getSetting() {
		this.http.get('/admin/common/settingKey',{params:{'key':'app_channel'}}).then(response=>{
		  let data=response.data;
		  if(data.code!==0){
			alert(data.message);
		  } else{
			this.channel_list = data.data;
		  }
		}).catch(()=>{
		  this.$Message.error('网络错误');
		});
	},
	getAppList(page) {
    this.page = page;
    let p = {'page' : page}
    let params = Object.assign(this.search, p);
		this.http.get('/admin/common/appList',{params:params}).then(response=>{
		  let data=response.data;
		  if(data.code!==0){
			alert(data.message);
		  } else{
			this.app_list = data.data.list;
        this.total = data.data.total;
		  }
		}).catch(()=>{
		  this.$Message.error('网络错误');
		});
	},
	updateApp(){
		this.http.post('/admin/common/updateApp',{
				  id:this.app.id,
				  content:this.app.content,
				  download_url:this.app.download_url,
				  is_force:this.app.is_force,
				  app_version:this.app.app_version,
      lang:this.app.lang,
				  channel:this.app.channel
		}).then(response=>{
		  let data=response.data;
		  if(data.code!==0) {
		    this.$Message.error(data.message);
		    return false;
		  } else{
		    this.$Message.info(data.message);
		    this.showmodal = false;
			this.getAppList();
		    return true;
		  }
		});
	},
	shelfs(id, status){
		this.$Modal.confirm({
			content: '<p>确定操作</p>',
			onOk: () => {
				this.http.post('/admin/common/shelfsApp',{id:id,status:status}).then(response=>{
				  let data=response.data;
				  if(data.code!==0) {
				    this.$Message.error(data.message);
				    return false;
				  } else{
				    this.$Message.info(data.message);
					this.getAppList();
				    return true;
				  }
				});
			},
			onCancel: () => {
				
			}
		});	
	},
	doUpload() {
	  	this.http.get('/admin/material/getUpoadVideoToken').then(response=>{
			let data=response.data;
			console.log(data);
			if(data.StatusCode!=200){
				this.$Message.error(data.message);
			} else {
				const config = data;
				console.log(config);
	
				const ossClient = new OSS({
					accessKeyId: config.AccessKeyId,
					accessKeySecret: config.AccessKeySecret,
					stsToken: config.SecurityToken,
					bucket:config.bucket,
					region:config.RegionId,
					secure:true,
					endpoint:'oss-cn-zhangjiakou.aliyuncs.com'
				});
				
				const fileName = this.file.name;  
				//const fileName = '风平IP智造'+this.app.app_version+'.exe'
				 
				 const progress = (p, _checkpoint) => {
				   // Object的上传进度。
				   this.upLoadProgress_show = true;
				   this.upLoadProgress = parseInt(p*100);
				   //console.log(p); 
				   // 分片上传的断点信息。
				   //console.log(_checkpoint); 
				 };
				 
				ossClient.multipartUpload('freefishpc/app_download/'+fileName, this.file,{progress}).then(
					result => {     
						this.file = null;
						this.app.download_url = result.name;
						console.log(`Common upload ${fileName} succeeded, result === `, result)   
					}).catch(
						err => {     
							console.log(`Common upload ${fileName} failed === `, err);   
					}); 
			}
	  	}).catch(()=>{
	  	  this.$Message.error('网络错误');
	  	});
	},
    closeModal(){
		this.app.id = 0;
		this.app.is_force = 0;
		this.app.app_version = '';
		this.app.content = '';
		this.app.download_url = '';
		this.showmodal=false;
    }
  }

}
</script>
